import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  btn: {
    padding: '0.75rem',
    fontFamily: 'PP Object Sans',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1rem',
    cursor: 'pointer',
    color: neutral['100'],
    borderRadius: '0.5rem',
    border: `1px solid ${neutral['90']}`,
    '&:hover': {
      backgroundColor: neutral['10'],
    },
  },
});
